import { createStandardAction } from 'typesafe-actions'

export const uploadData = createStandardAction('do/upload')<void>()
